import LocalizedStrings from "react-localization";

let studioInfoStrings = new LocalizedStrings({
    en: {
        testimonialTitle1: "WHAT ",
        testimonialTitle2: "DEVELOPERS ",
        testimonialTitle3: "ARE SAYING",
        tetminonialHeaderInfo1: "JOIN",
        tetminonialHeaderInfo2: " LUDARE ",
        tetminonialHeaderInfo3: "and unlock your game's full potential with the support of a thriving community. Here's why developers love working with us:",
        insightsTitle1: "GAIN",
        insightsTitle2: " INSIGHTS ",
        insightsTitle3: "ON YOUR USERS",
        insightsDesc: "Gather data on the things about your players that really matter. How they play and how often they play your game.",
        revenueTitle1: "GENERATE",
        revenueTitle2: " REVENUE ",
        revenueTitle3: "DURING EARLY DEVELOPMENT",
        revenueDesc: "Launch even before early access on Ludare to get more funding for your game than comparable platforms.",
        dataShareTitle1: "GET A",
        dataShareTitle2: " DIRECT DATA LINE ",
        dataShareTitle3: "TO PUBLISHERS",
        dataShareDesc: "Present more information to publishers beyond just wishlists. Share the information that really matters for decision making.",
        studioSignUpTitle1: "REGISTER NOW",
        studioSignUpTitle2: " TO GET ACCESS TO ALL MATERIALS",
        studioSignUpDesc: "Sign up to get access to more studio testimonials and tools to evaluate the Ludare platform",
    },
});

export default studioInfoStrings;